import Cards from 'components/activity/cards/main/containers/CardsContainer';
import { RouteConfig } from '../type';

const cardsRoutes: RouteConfig[] = [
    { path: '', element: <Cards />, pageTitle: 'Cards' },
];

export default cardsRoutes;
